import { Avatar, KpiMetricType, Plus, RowCards, SoftButton } from '@weareopenr/component-library';
import { DashboardWidget } from './DashboardWidget';
import { useMenus } from 'src/hooks/useMenus';
import { getLiveMenus } from 'src/helpers/menus/liveMenus';
import { useVenues } from 'src/hooks/useVenues/useVenues';
import { useMemo } from 'react';
import { StatusChip } from 'src/components/StatusChip/StatusChip';
import { Routes } from 'src/routes';
import { useNavigate } from 'react-router-dom';

export const MenusWidget = () => {
  const navigate = useNavigate();
  const { data: menus = [], isFetching: isMenusFetching } = useMenus();
  const { data: venues, isLoading: isVenuesLoading } = useVenues();
  const menusLive = useMemo(() => (venues ? getLiveMenus(venues) : []), [venues]);
  const menusWithLiveStatus = useMemo(
    () => (menus.length > 0 ? Math.round((menusLive.length / menus.length) * 100) : 0),
    [menusLive, menus],
  );
  const isEmpty = menus?.length === 0;
  return (
    <DashboardWidget
      title="Menus"
      emptyCta={
        <SoftButton icon={Plus} size="full-width" onClick={() => navigate(Routes.MENUS)}>
          Create a Menu
        </SoftButton>
      }
      link={{ label: 'View All', to: Routes.MENUS }}
      isEmpty={isEmpty}
      isLoading={isMenusFetching || isVenuesLoading}
      Kpis={[
        {
          id: 'menus-live',
          size: 'small',
          value: isEmpty ? 'N/A' : menusLive.length,
          label: 'Menu Live',
          testId: 'kpi-menus-live',
        },
        {
          id: 'menus-live-coverage',
          size: 'small',
          value: isEmpty ? 'N/A' : menusWithLiveStatus,
          label: 'Live menu coverage',
          testId: 'kpi-menus-live-coverage',
          metricType: isEmpty ? KpiMetricType.Text : KpiMetricType.Percentage,
        },
      ]}
    >
      <RowCards
        rows={menus.slice(0, 3).map((menu) => {
          const isLive = menusLive.some((liveMenu) => liveMenu.menuId === menu.menuId);

          return {
            key: menu.menuId,
            id: menu.menuId,
            leading: <Avatar imageUrl={menu.image} variant="custom" initials={menu.name[0]} />,
            title: menu.name,
            meta: [
              { label: `Created at ${new Date(menu.created).toLocaleString()}`, colour: 'liquorice', key: 'created' },
              {
                label: menu.ranges.length > 0 ? menu.ranges.join(', ') : 'No ranges',
                colour: 'liquorice',
                key: 'ranges',
              },
            ],
            action: {
              label: 'View Menu',
              to: `/menus/${menu.menuId}`,
            },
            chip: isLive && <StatusChip entity="menus" status="LIVE" />,
          };
        })}
      />
    </DashboardWidget>
  );
};
